import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";

const fmtAmount = (n) =>
  Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

const ConcessionPrint = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [ReportMonth, setReportMonth] = useState("");
  const [ReportYear, setReportYear] = useState("");
  const [totals, setTotals] = useState({ gross: 0, concession: 0, net: 0 });

  useEffect(() => {
    document.title = "Concession Report";
    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const reportYear = urlParams.get("ReportYear");
    const reportMonth = urlParams.get("ReportMonth");
    const wingId = urlParams.get("Wing_Id") || urlParams.get("Wing") || "0";
    const classId = urlParams.get("Class_Id") || urlParams.get("Class") || "0";
    const sectionId =
      urlParams.get("Section_Id") || urlParams.get("Section") || "0";
    const sessionId = urlParams.get("SessionID") || "0";

    setReportYear(reportYear);
    setReportMonth(reportMonth);

    axios({
      method: "post",
      url: config.base_url + "/Reports/GetConcessionReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        ReportYear: reportYear,
        ReportMonth: reportMonth,
        Wing_Id: Number(wingId) || 0,
        Class_Id: Number(classId) || 0,
        Section_Id: Number(sectionId) || 0,
        SessionID: Number(sessionId) || 0,
      },
    })
      .then(function (response) {
        const list = response.data?.ListofRecords;
        setLedger(Array.isArray(list) ? list : []);
        setTotals({
          gross: response.data?.TotalGrossFee ?? 0,
          concession:
            response.data?.TotalConcession ?? response.data?.TotalAmount ?? 0,
          net: response.data?.TotalNetFee ?? 0,
        });
        setLoading(false);
      })
      .catch(function () {
        setLedger([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      let countbreak = 1;
      return listOfLedger.map((item, index) => (
        <tr
          key={`${item.ConcessionRuleID}-${item.ConcessionCode}-${index}`}
          className={countbreak++ === 35 ? "page-break" : ""}
        >
          <td>{count++}</td>
          <td>{item.Concession_Rule_Name}</td>
          <td>{item.ConcessionCode}</td>
          <td className="text-end">{item.Concession_Percentage}%</td>
          <td className="text-end">{item.No_Of_Students}</td>
          <td className="text-end">{fmtAmount(item.GrossFee)}</td>
          <td className="text-end">{fmtAmount(item.ConcessionAmount)}</td>
          <td className="text-end">{fmtAmount(item.NetFee)}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="8">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <Page orientation="landscape" size="a4">
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th colSpan={8}>
              <PrintHeader
                title={`Concession Report for ${getMonthName(ReportMonth)} ${ReportYear}`}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan={8}>
                <Spinner animation="border" size="sm" />
              </td>
            </tr>
          ) : (
            <>
              <tr>
                <th>Sr#</th>
                <th>Concession Rule</th>
                <th>Code</th>
                <th className="text-end">%</th>
                <th className="text-end">Students</th>
                <th className="text-end">Gross Fee</th>
                <th className="text-end">Concession</th>
                <th className="text-end">Net Fee</th>
              </tr>
              {renderLedger()}
              <tr>
                <th colSpan={5} className="text-end">
                  Grand Total
                </th>
                <th className="text-end">
                  {fmtAmount(
                    totals.gross ||
                      calculateColumnTotal(listOfLedger || [], "GrossFee")
                  )}
                </th>
                <th className="text-end">
                  {fmtAmount(
                    totals.concession ||
                      calculateColumnTotal(
                        listOfLedger || [],
                        "ConcessionAmount"
                      )
                  )}
                </th>
                <th className="text-end">
                  {fmtAmount(
                    totals.net ||
                      calculateColumnTotal(listOfLedger || [], "NetFee")
                  )}
                </th>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default ConcessionPrint;
